module.exports = __webpack_public_path__ + "img/icon-dashboard.ab71f4ef.svg";